export enum ScenesList {
    LoadingScene = 'loading-scene',
    LevelScene = 'level-scene',
    UIScene = 'ui'
}

export enum AssetsList {
    IMG_BackGround = 'img-background',
    IMG_Coin = 'coin-icon',
    IMG_Ground = 'ground',
    IMG_Hero = 'hero',
    IMG_FontNumber = 'font:numbers',
    IMG_Key = 'key',
    IMG_Platform8x1 = 'grass:8x1',
    IMG_Platform6x1 = 'grass:6x1',
    IMG_Platform4x1 = 'grass:4x1',
    IMG_Platform2x1 = 'grass:2x1',
    IMG_Platform1x1 = 'grass:1x1',
    IMG_Walls = 'invisible-wall',
    SPRITESHEET_Door = 'door',
    SPRITESHEET_Coins = 'coin',
    SPRITESHEET_KeyIcon = 'key_icon',
    SPRITESHEET_Hero = 'hero:sprides',
    SPRITESHEET_Spider = 'spider',
    SND_Coin = 'snd-coin',
    SND_Door = 'snd-door',
    SND_Key = 'snd-key',
    SND_Jump = 'snd-jump',
    SND_Stomp = 'snd_stomp'
}

export enum EventList {
    GET_COIN = 'GET_COIN',
    KILL_SPIDER = 'KILL_SPIDER',
    HERO_JUMP = 'HERO_JUMP',
    OPEN_DOOR = 'OPEN_DOOR',
    GET_KEY = 'GET_KEY',
    GAME_END = 'GAME_END'
}